import React from "react";

const getRandomElement = (arr) => arr[Math.floor(Math.random() * arr.length)];

const randomString = (length) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

const randomPhoneNumber = () => {
  return '9' + Math.floor(Math.random() * 100000000).toString().padStart(8, '0');
};

const randomDate = () => {
  const start = new Date(1950, 0, 1);
  const end = new Date(2000, 0, 1);
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())).toISOString().split('T')[0];
};

// use for quick create staff onboard data
const StaffOnboardStateDev = {
  english_name: randomString(10),
  english_name_alias: randomString(8),
  chinese_name: "張三",
  date_of_birth: randomDate()?.toString(),
  hkid: "A" + Math.floor(Math.random() * 1000000).toString().padStart(6, '0'),
  hkid_last_digit: Math.floor(Math.random() * 10).toString(),
  nationality: getRandomElement(["Hong Kong", "China", "USA", "UK"]),
  gender: getRandomElement(["Male", "Female"]),
  marriage_status: getRandomElement(["Single", "Married"]),
  chinese_address: "香港中環",
  english_address: randomString(15) + " Street, Central, Hong Kong",
  phone_number: randomPhoneNumber(),
  whatsapp_number: randomPhoneNumber(),
  house_phone_number: randomPhoneNumber(),
  email: randomString(5) + "@example.com",
  bank_account_holder: randomString(10),
  bank_name: getRandomElement(["HSBC", "Bank of China", "Standard Chartered"]),
  bank_account_number: Math.floor(Math.random() * 1000000000).toString().padStart(10, '0'),
  emergency_contact_name: randomString(8),
  emergency_contact_relationship: getRandomElement(["Father", "Mother", "Sibling", "Friend"]),
  emergency_contact_phone_number: randomPhoneNumber(),
  emergency_contact_house_number: randomPhoneNumber(),
  staff_signature: '',
  staff_signature_date: "",
  staff_code: "",
  token: "",
  brand: "",
  link: "",
  area: "",
};

const StaffOnboardStateProd = {
  english_name: "",
  english_name_alias: "",
  chinese_name: "",
  date_of_birth: null,
  hkid: "",
  hkid_last_digit: "",
  nationality: "",
  gender: null,
  marriage_status: null,
  chinese_address: "",
  english_address: "",
  phone_number: "",
  whatsapp_number: "",
  house_phone_number: "",
  email: "",
  bank_account_holder: "",
  bank_name: "",
  bank_account_number: "",
  emergency_contact_name: "",
  emergency_contact_relationship: "",
  emergency_contact_phone_number: "",
  emergency_contact_house_number: "",
  staff_signature: '',
  staff_signature_date: "",
  staff_code: "",
  token: "",
  brand: "",
  link: "",
  area: "",
};

export const StaffOnboardState = process.env.NODE_ENV === 'development' ? StaffOnboardStateDev : StaffOnboardStateProd;

export const isIpad = () => {
  const userAgent = navigator?.userAgent;
  return !!(/iPad|Macintosh/.test(userAgent) && "ontouchend" in document);
};